import React from 'react'
import Button from 'react-bootstrap/Button'
import LoadingSpinner from '../loadingSpiner'



const SkipButton = (props)=>{
    return(
        <Button 
            className="model-skip-button"
            variant="light"
            disabled={props.disabled}
            style={{
                border: '2px solid #0C8444',
            }}
            onClick={props.submit}
            >
            {!props.disabled ? 
                <span>
                    {props.title}
                </span> :
                <div style={{
                    marginLeft: '35%'
                }}>
                    <LoadingSpinner
                        color={'#1D834F'}/>
                </div>
                
            }
            
        </Button>
    )
}

export default SkipButton